var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobinteview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3135682",
    clipPath: "url(#clip0_1_2357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.3507 16H60.7619C57.0275 16 54 18.9702 54 22.6343V29.0335L55.6365 30H67V17.1668L66.3507 16Z",
    fill: "#EFC984"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M77.9991 60.4684C77.9991 56.9271 75.6182 53.8096 72.1517 52.8121L62.4839 50.03L62.4901 48H58.1662L48.715 50.7191C45.3271 51.6938 43 54.7404 43 58.2012V73H78L77.9991 60.4684Z",
    fill: "#4A80AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M82.3624 50.7187L73.0413 48H62.008L62 50.6683L71.3211 53.3871C74.6631 54.362 76.9587 57.4085 76.9587 60.8691V73H88V58.2007C88 54.7403 85.7044 51.6936 82.3624 50.7187Z",
    fill: "#407093"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71 73L67.4324 58H63.5676L60 73H71Z",
    fill: "#DD636E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70 49.7328V41H60V49.7328C60 52.7333 64.9999 53 64.9999 53C64.9999 53 70 52.7331 70 49.7328Z",
    fill: "#FFDDCE"
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M66.7684 37.9057C66.9342 37.2044 67 36.4847 67 35.7655V24.8516C64.9529 24.9842 62.8856 24.7365 60.9135 24.1079L60.9097 24.1067C59.5134 23.6615 58.0745 24.6649 58.0745 26.0839V27.1639C58.0745 28.2533 57.1592 29.1365 56.0301 29.1365H54V32.3621C54 33.1864 54.6926 33.8546 55.5469 33.8546C55.8164 33.8546 56.0358 34.0583 56.0527 34.3178C56.3298 38.5584 59.474 42.048 63.6368 43C65.1766 41.6797 66.2945 39.9115 66.7684 37.9057Z",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M74.1905 19.8562H74.0958C73.5718 19.8562 73.1469 19.4203 73.1469 18.8826C73.1469 17.2906 71.889 16 70.3375 16H66V30H75.4351L77 29.0335V22.7388C77 21.1468 75.7423 19.8562 74.1905 19.8562Z",
    fill: "#EABC6B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M74.9792 29.3343C73.8554 29.3343 72.9444 28.4171 72.9444 27.2856V26.1644C72.9444 24.6905 71.5122 23.6484 70.1226 24.1109C68.6364 24.6054 67.096 24.8706 65.5511 24.9116V35.8751C65.5511 36.6093 65.4866 37.3442 65.3245 38.06C64.8345 40.2241 63.6407 42.1174 62 43.4864C62.9834 43.8182 64.0351 44 65.1295 44C70.3579 44 74.6326 39.8976 74.957 34.7155C74.9739 34.446 75.1922 34.2344 75.4605 34.2344C76.3107 34.2344 77 33.5404 77 32.6843V29.3342L74.9792 29.3343Z",
    fill: "#FFCBBE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M58.357 47.1511L56.8146 47.7734C55.9341 48.1286 55.7215 49.1658 56.4034 49.7796L60.6752 53.6242C61.217 54.0981 62.0699 54.1274 62.6502 53.6918L66 51.1775L60.2891 47.3428C59.7316 46.9682 58.9919 46.8949 58.357 47.1511Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M71.019 47.3653L66 51.2266L68.8853 53.6776C69.4138 54.1267 70.1991 54.1041 70.7008 53.6253L74.6176 49.8355C75.2578 49.2161 75.0665 48.1503 74.2502 47.7888L72.8092 47.1509C72.2181 46.8895 71.5304 46.9719 71.019 47.3653Z",
    fill: "#365E7D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M78 86.2271L77.9986 69H21V88H76.8881C77.5141 87.6604 77.9514 86.9939 78 86.2271Z",
    fill: "#DDB7A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M76.9827 69V86.033C76.9146 87.1194 76.0574 88 75 88H84.3669C86.3733 88 88 86.3288 88 84.2674V69H76.9827Z",
    fill: "#D6A889"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M27 65.0051V57H17V65.0051C17 67.7556 22 68 22 68C22 68 27 67.7556 27 65.0051Z",
    fill: "#FFDDCE"
  }))))))))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M21.9756 59.7805C24.3854 58.9161 26.0008 56.5695 26 53.934C25.9995 52.4767 25.7935 51.0273 25.3886 49.6313C24.7227 47.3364 24.3839 44.9532 24.3832 42.5572V42.5513C24.3816 37.0446 21.3011 32.2845 16.825 30C11.9879 32.0129 8.57328 36.906 8.57159 42.6236V42.6294C8.57092 44.9584 8.24178 47.2749 7.59434 49.5057C7.20059 50.8627 7.00034 52.2715 7 53.6881C6.99915 56.2499 8.56922 58.5308 10.9117 59.3711C13.1216 60.1637 15.3928 60.7066 17.6864 61C19.134 60.6921 20.5669 60.2859 21.9756 59.7805Z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M36.3838 49.3347C35.7127 47.1202 35.3713 44.8209 35.3706 42.5093V42.5035C35.3684 35.0451 29.2548 29 21.7142 29C19.6734 29 17.739 29.4459 16 30.2396C20.6862 32.3786 23.9408 37.0636 23.9423 42.5035V42.5093C23.943 44.821 24.2843 47.1203 24.9555 49.3347C25.3637 50.6814 25.5713 52.0799 25.5717 53.4859C25.5726 56.0287 23.9448 58.293 21.5162 59.1269C19.7104 59.747 17.865 60.2128 16 60.525C21.6473 61.4704 27.4764 61.0046 32.9445 59.1269C35.3731 58.2928 37.0009 56.0287 37 53.4859C36.9995 52.08 36.7919 50.6816 36.3838 49.3347Z",
    fill: "#365E7D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M38 18.1893V3.81072C38 0.30666 34.8946 0.00184938 32.7534 0H9.87994C7.73712 0 6 1.70613 6 3.81072V18.1893C6 20.2939 7.73712 22 9.87994 22H33.3653L34.3133 21.9497C35.4707 21.8884 36.5696 21.3551 37.2538 20.4363C37.723 19.8063 38 19.0296 38 18.1893Z",
    fill: "#CBE2FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M44.1529 0H33C35.1246 0 36.8469 1.76296 36.8469 3.93766V18.7952C36.8469 20.6896 35.5397 22.2712 33.7982 22.6474C33.7276 22.6626 33.6636 22.6929 33.6068 22.7328H37.2042C37.3529 22.7328 37.4954 22.7933 37.6006 22.901L43.359 28.7951C43.7865 29.2328 44.5177 28.9228 44.5177 28.3039V23.2057C44.5177 22.939 44.6962 22.7024 44.9511 22.6474C46.6926 22.2712 48 20.6898 48 18.7952V3.93766C47.9998 1.76296 46.2775 0 44.1529 0Z",
    fill: "#BED8FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M33 74.4619C33 71.0138 31.0957 69.349 27.5197 68.5671L25.499 68.1753C24.0459 67.8936 22.926 66.7788 22.5732 65.3732C20.2549 65.7772 17.7046 64.6627 16.6668 62.0296L16.6551 62L5.48069 64.2007C2.23182 65.1719 0 68.2075 0 71.6559V84.2943C0 86.3438 1.63362 88.0042 3.64614 88L32.182 87.9404L32.9816 87.316L33 74.4619Z",
    fill: "#E28086"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M42.3276 87.9906C43.2534 87.9833 44 87.2282 44 86.2992V71.6568C44 68.1965 41.7274 65.1501 38.4186 64.1753L27.0339 62C26.1209 64.2779 24.0631 65.4211 22 65.4319C22.2064 67.0566 23.429 68.3947 25.0679 68.7079L27.1259 69.101C30.7677 69.8859 32.7073 71.5564 32.7073 75.0167V88L42.3276 87.9906Z",
    fill: "#DD636E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M69.3203 53.4623L66.1322 51L62.7401 53.5595C62.5215 53.7244 62.2645 53.8236 62 53.8586L64.0248 57H67.9978L70 53.7589C69.7559 53.7154 69.5211 53.6176 69.3203 53.4623Z",
    fill: "#E28086"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobinteview);
export default __webpack_public_path__ + "static/media/jobinteview.07be8b8fbc7656d6364fb44261a2487f.svg";
export { ForwardRef as ReactComponent };